import { CLOSE_SUB_MENU_PANEL_EVENT } from '../../../navigation-header/v1/js/navigation-header-events.js';

export default class NavigationPanelProduct extends CoreJS.BaseComponent {
  static CLASS_NAMESPACE = 'navigation-panel-product';
  static ANIMATION_DURATION_IN_MS = 200;

  /** @inheritDoc */
  constructor(componentHost, componentName) {
    super(componentHost, componentName);
  }

  /** @inheritDoc */
  initialize() {
    this.navigationPanel = this.componentHost.querySelector('.ace-nav-panel-product');
    this.imageContainer = this.componentHost.querySelector('.ace-nav-panel-product__image');
    this.listItems = this.componentHost.querySelectorAll('.ace-nav-panel-product__link');
    this.closePanel = this.componentHost.querySelector('.ace-nav-panel-product__image--cancel');
    this.defaultImage = this.componentHost.querySelector('.ace-nav-panel-product__content').getAttribute('data-image');
    this.ANIMATION_DURATION_IN_MS = NavigationPanelProduct.ANIMATION_DURATION_IN_MS;

    // Set default image on page load
    this.setImageBackground(this.defaultImage);

    this.listItems.forEach((link) => {
      link.addEventListener(CoreJS.DomEventConstants.MOUSE_ENTER, this.handleMouseEnter.bind(this));
      link.addEventListener(CoreJS.DomEventConstants.CLICK, this.handleClosePanelClick.bind(this));
    });

    this.closePanel.addEventListener(CoreJS.DomEventConstants.CLICK, this.handleClosePanelClick.bind(this));
  }

  handleMouseEnter(e) {
    const url = e.target.getAttribute('data-image');
    this.imageContainer.classList.add('hidden');
    setTimeout(() => {
      this.setImageBackground(url);
      this.imageContainer.classList.remove('hidden');
    }, NavigationPanelProduct.ANIMATION_DURATION_IN_MS);
  }

  handleClosePanelClick() {
    const clickEvent = new CustomEvent(CLOSE_SUB_MENU_PANEL_EVENT);
    document.dispatchEvent(clickEvent);
  }

  setImageBackground(url) {
    if (url) {
      this.imageContainer.style.setProperty('--nav-panel-product-background-image', `url("${url}")`);
    } else {
      console.warn('Invalid image URL provided:', url);
    }
  }
}

// Registering component in component factory.
CoreJS.BaseComponent.registerComponent(NavigationPanelProduct.CLASS_NAMESPACE, NavigationPanelProduct);
